export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/uriel-soberanes-fe3a7838dddb1fbf6901af17ca246ea1.jpg";